import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SearchResourceType } from '@app/core/model/search/search-resource-type';
import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { BsshDatePipe } from '@app/core/utilities/pipes/bssh-date.pipe';
import { BytesPipe } from '@app/core/utilities/pipes/bytes.pipe';
import { StatusToDisplayName } from '@app/core/utilities/pipes/status-to-display-name.pipe';
import { SearchColumnFields, SearchGridOptionsFormatter } from '@app/search/gridOptions/search-grid-options-formatter';
import { BiosampleLibraryPrepResourceMatcherGridOptionsFormatter } from './biosample-library-prep-resource-matcher-grid-options-formatter';
import { SampleResourceMatcherGridOptionsFormatter } from './sample-resource-matcher-grid-options.formatter';
import { DatasetResourceMatcherGridOptionsFormatter } from './dataset-resource-matcher-grid-options.formatter';
import { AppResultResourceMatcherGridOptionsFormatter } from './app-result-resource-matcher-grid-options.formatter';

export interface IResourceMatcherGridOptionsFactoryService {
  getGridOptionsFormatterForResource(resourceType: SearchResourceType): SearchGridOptionsFormatter<SearchColumnFields>;
}

@Injectable({
  providedIn: 'root'
})
export class ResourceMatcherGridOptionsFactoryService implements IResourceMatcherGridOptionsFactoryService {

  constructor(
    private resourceDictionaryService: SearchResourceDictionaryService,
    private bytePipe: BytesPipe,
    private bsshDatePipe: BsshDatePipe,
    private http: HttpClient,
    private statusToDisplayName: StatusToDisplayName
  ) { }

  getGridOptionsFormatterForResource(resourceType: SearchResourceType): SearchGridOptionsFormatter<SearchColumnFields> {
    switch (resourceType) {
      case SearchResourceType.BiosampleLibraryPrep:
        return new BiosampleLibraryPrepResourceMatcherGridOptionsFormatter(this.resourceDictionaryService, this.bsshDatePipe, this.http);
      case SearchResourceType.Sample:
        return new SampleResourceMatcherGridOptionsFormatter(this.resourceDictionaryService, this.bsshDatePipe, this.http);
      case SearchResourceType.Dataset:
        return new DatasetResourceMatcherGridOptionsFormatter(this.resourceDictionaryService, this.bsshDatePipe, this.bytePipe, this.http, this.statusToDisplayName);
      case SearchResourceType.AppResult:
        return new AppResultResourceMatcherGridOptionsFormatter(this.resourceDictionaryService, this.bsshDatePipe, this.http);
      default:
        throw Error(`Resource Matcher Grid Options for ${resourceType} not supported.`);
    }
  }
}

